// extracted by mini-css-extract-plugin
module.exports = {"container":"Incident_container__LMEp3","page":"Incident_page__mPori","section":"Incident_section__p9BU6"};